// 📄 components/common/HomeCard.tsx
// Card clickeable reutilizada por las vistas "índice" del proyecto
// (ProjectSolutionsHome.tsx, HerramientasHome.tsx) — antes cada una tenía
// su propia copia del mismo markup (icono + label + tagline, mismas
// clases). Única fuente ahora, y único lugar donde vive la estrella de
// favorito (FavoriteStar), opcional vía isFavorite/onToggleFavorite.
import React from 'react';
import FavoriteStar from './FavoriteStar.tsx';

interface HomeCardProps {
  icon: React.ReactNode; // emoji string o un ícono lucide ya envuelto (ver IconoDe en menuConfig.tsx)
  label: string;
  tagline: string;
  onClick: () => void;
  isFavorite?: boolean;
  onToggleFavorite?: () => void | Promise<void>;
}

export default function HomeCard({ icon, label, tagline, onClick, isFavorite, onToggleFavorite }: HomeCardProps) {
  return (
    <div
      onClick={onClick}
      className="relative cursor-pointer bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-6 transition-all"
    >
      {onToggleFavorite && (
        <FavoriteStar active={!!isFavorite} onToggle={onToggleFavorite} className="absolute top-3 right-3" />
      )}
      <div className="text-3xl mb-3 text-blue-400">{icon}</div>
      <h3 className="text-white font-semibold mb-1 pr-8">{label}</h3>
      <p className="text-sm text-gray-400">{tagline}</p>
    </div>
  );
}
